/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 9eddebd4 (Tue Feb 17 18:34:36 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
/**
 *
 * @export
 * @interface AgreementSigningUrl
 */
export interface AgreementSigningUrl {
  /**
   * The url to access the page to sign an agreement.
   * @type string
   * @memberof AgreementSigningUrl
   */
  signingUrl?: string
}

export function AgreementSigningUrlFromJSON(json: any): AgreementSigningUrl {
  return AgreementSigningUrlFromJSONTyped(json, false)
}

export function AgreementSigningUrlFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): AgreementSigningUrl {
  if (json === undefined || json === null) {
    return json
  }
  return {
    signingUrl: !exists(json, 'signingUrl') ? undefined : json['signingUrl'],
  }
}

export function AgreementSigningUrlToJSON(
  value?: AgreementSigningUrl | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    signingUrl: value.signingUrl,
  }
}
